import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()

export class EnvironmentsService {
  private configuration = '${APP_CONFIG}';
  private env: any;
  selectedLang: string;
  selectedLanguage = new BehaviorSubject("");
  selectedLanguage$: Observable<string> = this.selectedLanguage.asObservable();
  private nodeEnvironment: string;
  private iframeSrc= "";

  constructor() {
    this.nodeEnvironment =
      this.configuration === '' || this.configuration.startsWith('$')
        ? ''
        : `.${this.configuration}`;
    this.env = require('../../environments/environment' + this.nodeEnvironment);
  }

  get config() {
    return this.env.environment;
  }

  get isStgMode(): boolean {
    return this.nodeEnvironment === '.stage';
  }

  get isProdMode(): boolean {
    return this.nodeEnvironment === '.prod';
  }
}



// WEBPACK FOOTER //
// ./src/app/services/enviornment.service.ts